export enum BetslipUpsellConstants {
    TrackingCategoryEvent = 'Upsell',
    TrackingLabelEvent = 'Sports Upsell',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    TrackingSource = 'Upsell',
    UpSellBetSlip = 'upsell-betslip',
    UpSellMyBets = 'upsell-mybets',
}
